import { ReactComponent as Group } from '../resources/images/svg/group.svg';
import { ReactComponent as Ticket } from '../resources/images/svg/ticket.svg';
import { ReactComponent as Calendar } from '../resources/images/svg/calendar.svg';
import { ReactComponent as PaymentCard } from '../resources/images/svg/paymentCard.svg';
// import { ReactComponent as BookedTicket } from '../resources/images/svg/bookedTicket.svg';
import { ReactComponent as Instructions } from '../resources/images/svg/instructions.svg';
import { ReactComponent as RefundedTicketIcon } from '../resources/images/svg/refundedTicket.svg';
import { ReactComponent as PurchasedTicketIcon } from '../resources/images/svg/purchasedTicket.svg';

// eslint-disable-next-line import/prefer-default-export
export const profileItems = [
  {
    id: 2,
    icon: <Ticket />,
    text: 'purchase_ticket',
    link: 'search',
  },
  {
    id: 3,
    icon: <Calendar />,
    text: 'schedule',
    link: 'schedule',
  },
  {
    id: 4,
    icon: <Instructions className="h-5 w-5" />,
    text: 'menu',
    link: 'info-content',
  },
];

// eslint-disable-next-line import/prefer-default-export
export const navigationItems = [

  {
    id: 1,
    icon: <PurchasedTicketIcon className="h-5 w-5" />,
    text: 'purchased_tickets',
    link: 'profile?tab=purchased-tickets',
  },
  {
    id: 2,
    icon: <RefundedTicketIcon className="h-5 w-5" />,
    text: 'refunded_tickets',
    link: 'profile?tab=refunded-tickets',
  },
  // {
  //   id: 3,
  //   icon: <BookedTicket className="h-5 w-5" />,
  //   text: 'reservations',
  //   link: 'profile?tab=booked-statements',
  // },
  {
    id: 4,
    icon: <Group className="h-5 w-5" />,
    text: 'saved_passengers',
    link: 'profile?tab=saved-passengers',
  },
  {
    id: 5,
    icon: <PaymentCard className="h-5 w-5" />,
    text: 'payment_cards',
    link: 'profile?tab=payment-cards',
  },
];

export const bankTypesToCountry = {
  AM: [{ name: 'AMERIA', type: 'card_choose' },
    // { name: 'IDRAM', type: 'payment_platform' }
  ],
  GE: [{ name: 'LIBERTY', type: 'card_choose' }],
};

export const bankTypeToCountry = {
  AM: 'AMERIA',
  GE: 'LIBERTY',
};

export const seatClasses = {
  5: '/seatClassLogos/businessClass.png',
  1: '/seatClassLogos/economyClass.png',
  2: '/seatClassLogos/economyClass.png',
  '2-12': '/wagon-icons/disabled.png',
  'I Class': '/seatClassLogos/economyClass.png',
  'group-2': '/wagon-icons/disabled.png',
  'II Class': '/seatClassLogos/economyClass.png',
  Business: '/seatClassLogos/businessClass.png',
};

export const statementStatuses = {
  new: {
    className: '',
    title: 'დასტურის მოლოდინში',
  },
  rejected: {
    title: 'უარყოფილი',
    className: 'canceled-tickets',
  },
  approved_for_invoice: {
    className: 'active-tickets',
    title: 'დადასტურებული',
  },
  approved_for_ticket: {
    className: 'active-tickets',
    title: 'დადასტურებული გაბილეთიანება',
  },
  approved_with_invoice: {
    className: 'active-tickets',
    title: 'დადასტურებული ინვოისი',
  },
  in_progress: {
    className: 'active-tickets',
    title: 'მიმდინარეობს',
  },
  completed: {
    className: 'active-tickets',
    title: 'დასრულებულია',
  },
};

export const georgianAlphabet = [
  'ა', 'ბ', 'გ', 'დ', 'ე', 'ვ', 'ზ', 'თ', 'ი', 'კ',
  'ლ', 'მ', 'ნ', 'ო', 'პ', 'ჟ', 'რ', 'ს', 'ტ', 'უ',
  'ფ', 'ქ', 'ღ', 'ყ', 'შ', 'ჩ', 'ც', 'ძ', 'წ', 'ჭ',
  'ხ', 'ჯ', 'ჰ',
];
